import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { THEME_UI_DEFAULT_KEY } from '../../theme-provider/types.esm.js';

var _body;
var fontWeights = {
  light: 300,
  body: 400,
  //    cosmos font-weight-regular
  heading: 500,
  semiBold: 600,
  bold: 700 //     cosmos font-weight-bold
};
// When supporting responsive array first indices needs to be an array, even if the line crop margin on for the top and bottom is the same
var helveticaHeaderLhCrop = {
  h1: [[0.32, 0.38], null, [0.32, 0.36]],
  h2: [[0.32, 0.36], null, null, null, null, 0.34],
  h3: [[0.34, 0.34], null, [0.32, 0.36]],
  h4: [[0.3, 0.36], 0.35, [0.32, 0.34], [0.32, 0.36]],
  h5: [[0.3, 0.34], [0.32, 0.36]],
  h6: [[0.34, 0.34], 0.35, [0.3, 0.36], [0.34, 0.36]]
};
var fonts = {
  fonts: {
    body: 'var(--font-sans)',
    heading: 'var(--font-sans)',
    monospace: 'var(--font-mono)',
    news: 'var(--font-serif)',
    costar: 'var(--font-costar)'
  },
  lhCrops: {
    body: (_body = {}, _defineProperty(_body, THEME_UI_DEFAULT_KEY, [0.3, 0.29]), _defineProperty(_body, "xxs", [0.5, 0.28]), _defineProperty(_body, 'xs-2', 0.35), _defineProperty(_body, 'xs-3', 0.28), _body),
    'text-container-expander': 0.3,
    heading: {
      h1: helveticaHeaderLhCrop.h1,
      h2: helveticaHeaderLhCrop.h2,
      h3: helveticaHeaderLhCrop.h3,
      h4: helveticaHeaderLhCrop.h4,
      h5: helveticaHeaderLhCrop.h5,
      h6: helveticaHeaderLhCrop.h6
    },
    monospace: 0.5 // Menlo
  },
  fontWeights: fontWeights,
  lineHeights: {
    body: 1.3,
    heading: 1.4
  },
  letterSpacings: {
    heading: '-0.05em',
    caps: '0.1em'
  }
};

export { fonts };
//# sourceMappingURL=fonts.esm.js.map
